<template>
  <div class="container" v-cloak>
    <div v-if="showFail" class="top-con u-flex-col u-col-center">
      <img src="../../assets/images/useAmount_pass.png" />
      <h4>申请成功，资料预审中</h4>
      <span class="u-text-center"> 请保持电话畅通，以免错过审核电话 </span>
    </div>
    <div v-else class="top-con u-flex-col u-col-center useAmount_disapprove">
      <img src="../../assets/images/useAmount_disapprove.png" />
      <h4>抱歉，申请未通过！</h4>
    </div>
    <div
      v-if="return_url"
      class="exclusive-customer-service u-flex-col u-col-center"
    >
      <div class="btn u-flex u-row-center" @click="handleOk">
        知道了 {{ time }}s
      </div>
    </div>

    <!-- 底部 -->
    <div class="bottom">
      温馨提示： <br />
      吉用花为您提供贷款咨询推荐服务，在使用服务过程中遇到的任何预先收费、网络转账、索要银行卡密码、索要手机验证码行为均有诈骗风险，请保持警惕避免损失。同时您知悉您已授权吉用花基于向您推荐贷款咨询服务之目的，将您的个人信息提供给贷款咨询服务机构，请特别关注机构是否按照您的授权使用您的个人信息并向您提供贷款咨询服务。如有问题，可与我司联系，400-11129-897
    </div>
  </div>
</template>

<script>
export default {
  name: "UseAmountResult",
  data() {
    return {
      showFail: this.$route.query.showFail == 0 ? false : true,
      time: 5,
      return_url: sessionStorage.getItem("return_url") || null,
    };
  },
  mounted() {
    let timer = setInterval(() => {
      if (this.time > 0) {
        this.time--;
      } else {
        clearInterval(timer);
        this.handleOk();
      }
    }, 1000);
  },
  methods: {
    // 好的按钮点击
    handleOk() {
      this.time = 5; //恢复默认值
      var timestamp = new Date().getTime();
      if (this.return_url) {
        window.location.href = this.return_url + "?tsp=" + timestamp;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #f6f6f6;
  padding: 0 0.4rem 0.8rem;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  .top-con {
    padding: 0.43rem 0 0.96rem;
    color: #000;
    font-family: PingFangSC, PingFang SC;
    font-weight: normal;
    &.useAmount_disapprove {
      padding-bottom: 1.51rem;
    }
    > img {
      width: 1.2rem;
      height: 1.2rem;
    }

    > h4 {
      font-size: 0.32rem;
      margin: 0.22rem 0 0.18rem;
      font-weight: 400;
      font-size: 0.34rem;
      color: #333333;
      line-height: 0.48rem;
    }

    > span {
      font-weight: 400;
      color: #8c8c8c;
      line-height: 0.37rem;
      font-size: 0.26rem;
    }
  }

  .exclusive-customer-service {
    font-size: 0.28rem;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: normal;
    color: #192337;
    .btn {
      border-radius: 0.48rem;
      color: #ffffff;
      width: 6.18rem;
      height: 0.98rem;
      background: #e71a0f;
      box-shadow: 0rem 0.06rem 0.14rem 0rem rgba(252, 43, 30, 0.29);
      border-radius: 0.51rem;
      font-weight: 500;
      font-size: 0.34rem;
      color: #ffffff;
      line-height: 0.98rem;
    }
  }
  .bottom {
    margin: 0.71rem auto 0;
    font-family: PingFangSC, PingFangSC-Regular;
    font-size: 0.22rem;
    color: #c0c0c0;
    font-weight: 500;
    line-height: 0.36rem;
    text-align: justify;
    letter-spacing: 0.01rem;
    padding: 0 0.3rem;
  }
}
</style>
